import { memo, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

// -----------------------------------------------------------------------------

const ServiceConnectionInstructions = memo(
  function ServiceConnectionInstructions({
    label,
    forceCollapse,
    children,
  }: ServiceConnectionInstructionsProps) {
    const [hideInstructions, setHideInstructions] = useState(false);

    //
    useEffect(() => {
      if (forceCollapse != null) {
        setHideInstructions(true);
      }
    }, [forceCollapse]);

    //
    const toggleLabel = hideInstructions
      ? "Show instructions"
      : "Hide instructions";

    //
    return (
      <>
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              flexWrap: "wrap",
              mb: 2,
            }}
          >
            <Typography variant="h4" fontWeight="bold" sx={{ mt: 1, mr: 1 }}>
              {label}
            </Typography>
            <span style={{ flexGrow: 1 }} />
            <Button
              variant="text"
              onClick={() => {
                setHideInstructions((hideInstructions) => !hideInstructions);
              }}
            >
              {toggleLabel}
            </Button>
          </Box>
          {hideInstructions ? null : children}
        </Box>
        <Divider sx={{ mt: 2, mb: 2 }} />
      </>
    );
  }
);

export default ServiceConnectionInstructions;

// -----------------------------------------------------------------------------

interface ServiceConnectionInstructionsProps {
  label: string;
  forceCollapse?: Date;
  children: React.ReactNode;
}
